export const faqs = [
  {
    question: '91.cn com是什么类型的平台？',
    answer: '91.cn com是一个综合性网络内容平台，汇聚了丰富的数字内容资源，涵盖多个领域和类别，为用户提供便捷的内容发现和消费服务。',
  },
  {
    question: '如何注册91.cn com账号？',
    answer: '访问91.cn com官方网站，点击右上角的"注册"按钮，按照提示填写用户名、密码和邮箱信息，完成验证后即可成功注册。注册过程简单快捷，全程不超过3分钟。',
  },
  {
    question: '91.cn com是否免费使用？',
    answer: '91.cn com提供基础免费服务，用户可以免费浏览和使用平台的基础功能。部分高级内容或增值服务可能需要付费，但平台会在付费前明确提示用户。',
  },
  {
    question: '如何保障账号安全？',
    answer: '建议设置强密码（包含大小写字母、数字和特殊字符）、开启二次验证、定期更换密码、不在公共设备保存登录状态。平台也提供了多层安全防护机制保障用户数据安全。',
  },
  {
    question: '91.cn com支持哪些访问方式？',
    answer: '91.cn com支持多种访问方式，包括电脑网页端、手机移动网页端以及移动客户端（可在官方应用商店下载），满足用户在不同设备上的使用需求。',
  },
  {
    question: '遇到技术问题如何联系客服？',
    answer: '您可以通过平台内的"帮助中心"提交问题反馈，或发送邮件至官方客服邮箱。我们的客服团队7×24小时在线，通常会在2小时内回复您的问题。',
  },
  {
    question: '91.cn com的内容是否经过审核？',
    answer: '是的，91.cn com严格遵守相关法律法规，所有平台内容均经过严格的审核流程，确保内容合规、健康、安全，为用户提供放心的内容消费环境。',
  },
  {
    question: '如何反馈平台使用中的问题和建议？',
    answer: '您可以通过"帮助中心"的问题反馈功能提交意见和建议，或通过官方社交媒体渠道与我们互动。我们非常重视每一位用户的反馈，会认真评估并持续优化平台功能。',
  },
];

export const platformStats = [
  { label: '注册用户', value: '500万+', icon: 'ri-user-line' },
  { label: '内容资源', value: '100万+', icon: 'ri-file-copy-line' },
  { label: '日均访问', value: '80万+', icon: 'ri-eye-line' },
  { label: '服务年限', value: '10年+', icon: 'ri-time-line' },
];